import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Features", href: "#features", id: "features" },
  { label: "How It Works", href: "#how-it-works", id: "how-it-works" },
  { label: "Sample Issue", href: "#sample-issue", id: "sample-issue" },
  { label: "Pricing", href: "#pricing", id: "pricing" },
];

export const scrollToSection = (hash) => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(hash, { offset: -72, duration: 1.5 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Header = ({ openLead }) => {
  const [open, setOpen] = useState(false);

  const go = (hash) => {
    setOpen(false);
    scrollToSection(hash);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 border-b border-line bg-cream/90 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="logo-button"
          onClick={() => go("#top")}
          className="flex items-center gap-2.5"
        >
          <img
            src="/logo.jpg"
            alt="The Quarterly Pulse logo"
            className="h-10 w-10 rounded-full border border-walnut/15 object-cover shadow-[0_4px_14px_rgba(42,32,28,0.15)]"
          />
          <span className="font-serif text-xl font-medium tracking-tight text-walnut">
            The Quarterly Pulse
          </span>
        </button>

        <nav className="hidden items-center gap-9 md:flex" data-testid="desktop-nav">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-umber transition-colors duration-300 hover:text-terracotta"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-demo-button"
            onClick={openLead}
            className="rounded-full bg-walnut px-5 py-2.5 text-sm font-medium text-paper transition-colors duration-300 hover:bg-terracotta"
          >
            Request a Sample Recap
          </button>
        </nav>

        <button
          data-testid="mobile-menu-button"
          className="text-walnut md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-line bg-cream px-6 pb-6 pt-2 md:hidden" data-testid="mobile-menu">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.href)}
              className="block w-full py-3 text-left text-base font-medium text-umber"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-demo-button"
            onClick={() => {
              setOpen(false);
              openLead();
            }}
            className="mt-3 block w-full rounded-full bg-walnut px-5 py-3 text-center text-sm font-medium text-paper"
          >
            Request a Sample Recap
          </button>
        </div>
      )}
    </motion.header>
  );
};
